import {
  MeasurementRangeFragment,
  MeasurementUnits,
  QualifiedFeature,
} from "fe-common/graphql";
import { Relations } from "shared";
import { symptomQualifierTxt } from "../../../uiControllers/SymptomText";
import { MeasurementUnitsToString } from "../../../../utils/dataHelpers";
import {
  RangeBuilder,
  singleValueRangeBuilder,
  defaultRangeValueExtractor,
  RangeExtractor,
} from "./logic(controllerHooks)/singeValueRangeBuilder";

export interface NumericTimingConfig {
  connectingText?: string;
  rangeBuilder: RangeBuilder;
  unitsInPlural: boolean;
  answerText?: (
    e: QualifiedFeature,
    translate: (id: string) => string,
  ) => { text: string };
  featureToRange: RangeExtractor;
}

export const numericTimingConfig: { [key: string]: NumericTimingConfig } = {
  // Most numeric questions are duration questions so this is pretty much the default
  [Relations.DURATION]: {
    rangeBuilder: singleValueRangeBuilder,
    featureToRange: defaultRangeValueExtractor,
    unitsInPlural: true,
    answerText: (qf: QualifiedFeature, translate) => {
      const durationText = symptomQualifierTxt(qf).join("");
      const [num, unit] = durationText.trim().split(" ");
      const answerText = num + " " + translate(unit.toLowerCase());
      return { text: answerText };
    },
  },
  // Frequency relations is used to describe how many times in a time period something happens:
  // 1 cigarette per day, 2 bleedings in a month etc...
  [Relations.FREQUENCY]: {
    rangeBuilder: (val, unit) => ({
      low: val,
      high: val,
      units: null,
      complexUnits: {
        numerator: [MeasurementUnits.Times],
        denominator: [unit],
      },
    }),
    unitsInPlural: false,
    connectingText: "FREQUENCY_CONNECTING_TEXT",
    answerText: (qf: QualifiedFeature, translate) => {
      const range = qf.qualifiers[0].range;
      const d = MeasurementUnitsToString(
        range.complexUnits.denominator[0],
        translate,
        null,
        false,
      );
      const n = translate("FREQUENCY_CONNECTING_TEXT");
      const val = range.low;
      const answerText = val + " " + n + translate(d.toLowerCase());
      return { text: answerText };
    },
    featureToRange: (range: MeasurementRangeFragment) => {
      return {
        value: range?.low,
        unit: range?.complexUnits?.denominator?.pop?.(),
      };
    },
  },
};
